export const DATA_SERVICES_SORT_OPTIONS = [
  { label: '개수 많은순', value: 'countDesc' },
  { label: '개수 적은순', value: 'countAsc' },
  { label: '가나다순', value: 'nameAsc' },
];
